import React from 'react';
import PropTypes from 'prop-types';
import { CheckBox } from '../../../v4/components';
import { EVENT_OPERATION } from '../../../data/enums/EventOperation';
import { PERMISSION_OBJ } from '../../../data/enums/Permission';
import { tableHeaderWithCheckBox, menuAction } from '../../../v4/components';

const labelMappings = {
  checkbox: 'checkbox',
  id: 'id',
  title: 'title',
  territory: 'territory',
  locationHierarchy: 'locationHierarchy',
  actionHolders: 'actionHolders',
};

const menuConfigList = [
  {
    title: 'Edit',
    icon: 'pencil',
    permissionDerivedBy: 'update',
    type: EVENT_OPERATION.UPDATE,
  },
  {
    title: 'Delete',
    icon: 'trash',
    permissionDerivedBy: 'delete',
    type: EVENT_OPERATION.DELETE,
  },
];

const labelConfig = [
  {
    id: 1,
    label: labelMappings.checkbox,
    title: '',
    show: true,
  },
  {
    id: 2,
    label: labelMappings.id,
    title: 'ID',
    show: true,
  },
  {
    id: 3,
    label: labelMappings.title,
    title: 'Title',
    show: true,
  },
  {
    id: 4,
    label: labelMappings.territory,
    title: 'Territory',
    show: true,
  },
  {
    id: 5,
    label: labelMappings.locationHierarchy,
    show: true,
    dynamicTitle: true,
  },
  {
    id: 6,
    label: labelMappings.actionHolders,
    title: '',
    show: true,
  },
];

const TableHeader = ({ dataListLength, checkedListLength, primaryCheckboxHandler, permission, lastLocation }) =>
  tableHeaderWithCheckBox(
    dataListLength,
    checkedListLength,
    primaryCheckboxHandler,
    permission,
    labelConfig,
    labelMappings,
    { 5: lastLocation && lastLocation.title },
  );

TableHeader.propTypes = {
  checkedListLength: PropTypes.number,
  dataListLength: PropTypes.number,
  permission: PropTypes.instanceOf(Object),
  primaryCheckboxHandler: PropTypes.func.isRequired,
};

TableHeader.defaultProps = {
  checkedListLength: 0,
  dataListLength: 0,
  permission: PERMISSION_OBJ,
};

const returnTableBody = (data, checkedList, onIconClick, onSecondaryCheckBoxClick, permission) => {
  const table = {};
  table[labelMappings.checkbox] = permission.delete && (
    <td key={`town-${data.id}-check`} onClick={(e) => e.stopPropagation()}>
      <CheckBox checked={checkedList.includes(data.id)} onCheckBoxClick={() => onSecondaryCheckBoxClick(data.id)} />
    </td>
  );
  table[labelMappings.id] = <td key={`town-${data.id}-id`}>{data.id}</td>;
  table[labelMappings.title] = <td key={`town-${data.id}-title`}>{data.title}</td>;
  table[labelMappings.territory] = <td key={`town-${data.id}-territory`}>{data.territory && data.territory.title}</td>;
  table[labelMappings.locationHierarchy] = (
    <td key={`${data.id}-location-hierarchy`}>
      {data.LocationHierarchyDetail && data.LocationHierarchyDetail.length > 0
        ? data.LocationHierarchyDetail[0].title
        : ''}
    </td>
  );
  table[labelMappings.actionHolders] = (
    <td key={`town-${data.id}-action`} className='text-right simple-popup-actions' onClick={(e) => e.stopPropagation()}>
      {menuAction(
        menuConfigList,
        { menuIcon: 'ellipsis-v' },
        onIconClick,
        {
          ...data,
          locationHierarchyDetailId:
            data.LocationHierarchyDetail && data.LocationHierarchyDetail.length > 0
              ? data.LocationHierarchyDetail[0].id
              : null,
        },
        permission,
      )}
    </td>
  );

  return table;
};

const TableBody = ({ data, checkedList, onIconClick, secondaryCheckboxHandler, permission }) => {
  const tableBody = returnTableBody(data, checkedList, onIconClick, secondaryCheckboxHandler, permission);

  return <tr key={data.id}>{labelConfig.map((label) => (label.show ? tableBody[label.label] : null))}</tr>;
};

TableBody.propTypes = {
  checkedList: PropTypes.instanceOf(Array),
  data: PropTypes.instanceOf(Object),
  onIconClick: PropTypes.func.isRequired,
  permission: PropTypes.instanceOf(Object),
  secondaryCheckboxHandler: PropTypes.func.isRequired,
};

TableBody.defaultProps = {
  data: {},
  checkedList: [],
  permission: PERMISSION_OBJ,
};

export { TableHeader, TableBody };
